'use client';

import axios from 'axios';
// Remove the import for getAuthToken since we won't be using it anymore
// import { getAuthToken } from './supabase-client';

/**
 * Creates an axios instance for API requests
 * 
 * NOTE: We no longer need to add Authorization headers as authentication
 * is now handled via cookies by the Supabase SSR client
 * 
 * @returns An axios instance
 */
export function createApiAxios() {
  return axios.create({
    // We don't need to set auth headers as authentication is handled via cookies
    withCredentials: true, // This ensures cookies are sent with requests
  });
}

/**
 * Makes an API request
 * @param url The URL to fetch
 * @param options Additional axios options
 * @returns The axios response
 */
export async function apiRequest(url: string, options: any = {}) {
  const apiAxios = createApiAxios();
  return apiAxios({
    url,
    ...options
  });
}

/**
 * Makes a GET request
 * @param url The URL to fetch
 * @param options Additional axios options
 * @returns The parsed JSON response
 */
export async function getWithAuth<T = any>(url: string, options: any = {}): Promise<T> {
  const response = await apiRequest(url, {
    method: 'GET',
    ...options
  });
  
  return response.data;
}

/**
 * Makes a POST request
 * @param url The URL to fetch
 * @param data The data to send
 * @param options Additional axios options
 * @returns The parsed JSON response
 */
export async function postWithAuth<T = any>(url: string, data: any, options: any = {}): Promise<T> {
  const response = await apiRequest(url, {
    method: 'POST',
    data,
    ...options
  });
  
  return response.data;
} 